import api from '../api/client';

export const comissoesService = {
  listar: (organizadorId, params = {}) => {
    const qs = new URLSearchParams();
    if (params.ativo !== undefined) qs.append('ativo', params.ativo);
    if (params.tipo) qs.append('tipo', params.tipo);
    const query = qs.toString();
    return api.get(`/organizadores/${organizadorId}/comissoes${query ? `?${query}` : ''}`);
  },
  
  buscarPorId: (organizadorId, id) => api.get(`/organizadores/${organizadorId}/comissoes/${id}`),
  
  buscarPadrao: (organizadorId) => api.get(`/organizadores/${organizadorId}/comissoes/padrao`),
  
  verificarEmUso: (organizadorId, id) => api.get(`/organizadores/${organizadorId}/comissoes/${id}/em-uso`),
  
  criar: (organizadorId, dados) => api.post(`/organizadores/${organizadorId}/comissoes`, dados),
  
  atualizar: (organizadorId, id, dados) => api.put(`/organizadores/${organizadorId}/comissoes/${id}`, dados),
  
  excluir: (organizadorId, id) => api.delete(`/organizadores/${organizadorId}/comissoes/${id}`),
  
  buscarPorTipo: (organizadorId, tipo) => api.get(`/organizadores/${organizadorId}/comissoes?tipo=${tipo}`),
  
  marcarPadrao: (organizadorId, id) => api.patch(`/organizadores/${organizadorId}/comissoes/${id}/marcar-padrao`),
  
  inativarLote: (organizadorId, ids, ativo = false) => api.patch(`/organizadores/${organizadorId}/comissoes/inativar-lote`, { ids, ativo }),
};
